import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useAfterTimeout} from "../../commonOpenSite/hooks/useAfterTimeout.hook";

const styles = require('./klInputError.component.scss');

interface KlInputErrorProps {
    errorCondition: boolean;
    errorText: string;
    className?: string;
    classNameOverride?: string;
    timeout?: number;
    hideIcon?: boolean;
    noMargin?: boolean;
}

export function KlInputError(props: KlInputErrorProps) {

    const {errorCondition, errorText, className, classNameOverride, timeout, hideIcon, noMargin} = props;
    const [showError, setShowError] = useState(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const showErrorCallback = useCallback(() =>  setShowError(false), [errorCondition]);
    useAfterTimeout(showErrorCallback, timeout);

    useEffect(() => {
        setShowError(true);
    }, [errorCondition]);

    const errorMessage = useMemo( (): string => {
        return errorCondition ? errorText : '';
    }, [errorCondition, errorText]);

    return (
        <>
            {showError && errorMessage &&
                <div className={`${classNameOverride || styles.errorMessageContainer} ${className || ''}`}>
                    <div className={`${styles.errorMessage} ${noMargin ? styles.noMargin : ''}`}>
                        {!hideIcon &&
                            <i className={`${styles.icon} fal fa-exclamation-circle`}/>
                        }
                        {errorMessage}
                    </div>
                </div>
            }
        </>
    );
}
